<template>
  <div>
    <ul class="fixedMiddleHeaderTab d-flex align-items-center holderCss">
      <li
        :class="tab == 'Overview' ? 'active' : ''"
        v-on:click.prevent="changeTab('Overview')"
      >
        <a href="#">{{ $t("tool_overview") }}</a>
      </li>
      <!-- <li :class="tab == 'AutoChartist-Scanner'? 'active': ''" v-on:click.prevent="changeTab('AutoChartist-Scanner')"><a href="#">{{$t('tool_autochartistScan')}}</a></li> -->
      <!-- <li :class="tab == 'AutoChartist-Web'? 'active': ''" v-on:click.prevent="changeTab('AutoChartist-Web')"><a href="#">{{$t('tool_autochartistWeb')}}</a></li> -->
      <li
        :class="tab == 'VPS' ? 'active' : ''"
        v-on:click.prevent="changeTab('VPS')"
      >
        <a href="#">{{ $t("tool_Vpsheading") }}</a>
      </li>
      <li
        :class="tab == 'Economic-Calendar' ? 'active' : ''"
        v-on:click.prevent="changeTab('Economic-Calendar')"
      >
        <a href="#">{{ $t("tool_ecoCalendar") }}</a>
      </li>
      <li
        :class="tab == 'Trader-Tool-Box' ? 'active' : ''"
        v-on:click.prevent="changeTab('Trader-Tool-Box')"
      >
        <a href="#">{{ $t("tool_tradingToolbox") }}</a>
      </li>
      <!-- <li :class="tab == 'Trader-Market-Place'? 'active': ''" v-on:click.prevent="changeTab('Trader-Market-Place')"><a href="#">Trader's Market Place</a></li> -->
      <li
        :class="tab == 'Calculators' ? 'active' : ''"
        v-on:click.prevent="changeTab('Calculators')"
      >
        <a href="#">{{ $t("tool_Calculator") }}</a>
      </li>
      <li
        :class="tab == 'Trading-Hours' ? 'active' : ''"
        v-on:click.prevent="changeTab('Trading-Hours')"
      >
        <a href="#">{{ $t("tool_tradingHOur") }}</a>
      </li>
      <!-- <li :class="tab == 'Signals'? 'active': ''" v-on:click.prevent="changeTab('Signals')"><a href="#">{{$t('tool_Signal')}}</a></li> -->
    </ul>
    <div class="row d-flex align-items-center justify-content-center mt-5">
      <div class="col-12 col-md-11">
        <div v-if="tab == 'Overview'">
          <app-over-view></app-over-view>
        </div>
        <div v-if="tab == 'AutoChartist-Scanner'">
          <app-autochartist-scanner></app-autochartist-scanner>
        </div>
        <div v-if="tab == 'AutoChartist-Web'">
          <auto-chartist-web></auto-chartist-web>
        </div>
        <div v-if="tab == 'VPS'">
          <app-vps></app-vps>
        </div>
        <div v-if="tab == 'Economic-Calendar'">
          <app-economic-calendar></app-economic-calendar>
        </div>
        <div v-if="tab == 'Trader-Tool-Box'">
          <app-tradertool-box></app-tradertool-box>
        </div>
        <div v-if="tab == 'Trader-Market-Place'">
          <tradersMarketplace></tradersMarketplace>
        </div>
        <div v-if="tab == 'Calculators'">
          <app-trading-calculator></app-trading-calculator>
        </div>
        <div v-if="tab == 'Trading-Hours'">
          <app-market-trading-hours></app-market-trading-hours>
        </div>
        <div v-if="tab == 'Signals'">
          <auto-chartist></auto-chartist>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OverView from "./pages/trading_tool";
import AutochartistScanner from "../tradingtools/autochartist_scanner";
import Vps from "./pages/vps";
import EconomicCalendar from "./pages/economic_calendar";
import trading_calculator from "./pages/trading_calculators";
import TradertoolBox from "../tradingtools/tradertool_box";
import market_trading_hours from "./pages/market_trading_hours";
import tradersMarketplace from "./pages/traders_marketplace";
import auto_chartist_web from "./pages/auto_chartist_web";
import autoChartist from "../tradingtools/autoChartist";
export default {
  name: "tools",
  data() {
    return {
      fxsymbolprice: "0",
      tab: "",
    };
  },
  components: {
    appOverView: OverView,
    appAutochartistScanner: AutochartistScanner,
    appVps: Vps,
    appEconomicCalendar: EconomicCalendar,
    appTradertoolBox: TradertoolBox,
    appTradingCalculator: trading_calculator,
    appMarketTradingHours: market_trading_hours,
    tradersMarketplace: tradersMarketplace,
    autoChartistWeb: auto_chartist_web,
    autoChartist,
  },
  methods: {
    changeTab(element) {
      this.tab = element;
      switch (element) {
        case 'Overview':
            this.$trackEvent('CP+Tools+Overview');
            break;
        case 'VPS':
            this.$trackEvent('CP+Tools+VPS');
            break;
        case 'Economic-Calendar':
            this.$trackEvent('CP+Tools+Economic+Calendar');
            break;
        case 'Trader-Tool-Box':
            this.$trackEvent('CP+Tools+Traders+tools+box');
            break;
        case 'Calculators':
            this.$trackEvent('CP+Tools+Calculators');
            break;
        case 'Trading-Hours':
            this.$trackEvent('CP+Tools+Trading+hours');
            break;
      }

      this.$router.replace({ name: "tools", params: { tabName: element } });
    },
  },
  created() {
    this.tab = this.$route.params.tabName;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/tools/tools.vue